import React,{ Component } from "react";
import { connect } from "react-redux";
import LdapForm from "../LdapForm/LdapForm";
import { createLdap, testLdapConfig } from "../../../actions/actionLdap";
import { Row, Col, Card, CardHeader, Container} from "reactstrap";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Ldap",path:"/ldap",isActive: false},
    {name: "CreateLdap",path:"/createldap",isActive: true},
];

class CreateLdap extends Component{
    render(){
        return (
            <div>    
                <BreadCrumbCompo routes={routes}/>   
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className = "user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Create LDAP Configuration</strong>
                                </CardHeader>
                                <LdapForm
                                    createLdap={this.props.createLdap}
                                />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}

CreateLdap.propTypes = {
    createLdap: Proptypes.func.isRequired,
    testLdapConfig: Proptypes.func.isRequired
};

export default connect(state => ({
    ldap_configs: state.ldap_configs.ldap_configs || []
}), 
dispatch => ({
    createLdap: (data) => dispatch(createLdap(data)),
    testLdapConfig: (data) => dispatch (testLdapConfig(data))
}))(CreateLdap);


// WEBPACK FOOTER //
// ./src/views/Ldap/CreateLdap/CreateLdap.js